/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/HTNow/ContactUsParts',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery-ui' 
], function ($, _, Roc, jqueryui) {
    'use strict';
 
    function init() {
        getCartItemsForContactus();
    };
    function getCartItemsForContactus() {
        $.ajax({
            type: 'GET',
            url: '/ajax/GetCartItemsForContactus',
            contentType: 'application/json; charset=utf-8',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};
                if (response.isSuccess && response.partsIncart) {
                    $('.partnumbers input[type="text"]').val(function (index, value) {
                        return response.partsIncart;
                    });
                }
            }
        });
    }
    function initAnalytics(isloggedin) {
        $.ajax({
            type: 'GET',
            url: '/ajax/GetCartItemsForContactus',
            contentType: 'application/json; charset=utf-8',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};
                if (response.isSuccess) {
                    if (isloggedin) { 
                        setAnaylticsforloggedinUsers();
                    } else {
                        setAnaylticsforNotloggedinUsers(response.partsIncart);
                    }
                }
            }
        });
    };
    function setAnaylticsforNotloggedinUsers(parts) { 
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSubmission',
            'formID': 'Contact',
            'partNo': parts
        });
        }

    function setAnaylticsforloggedinUsers() {  
       window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
           'event': 'formSubmission',
           'formID': 'quote_request_user'
       });
       };

    

    var ContactUsParts = {
        init: init,
        initAnalytics: initAnalytics
    };

    Roc.Logger.debug('ContactUsParts.js Loaded:', ContactUsParts);

    return ContactUsParts;
});

